// component name
$component: 'zr-bannerx-cta';

@use '../zr-theme/zr-variables.scss' as *;
@use '../zr-theme/functions/fonts' as f;

.#{$component}__wrapper {
    padding: 0 8px;
    display: flex;
    height: 100%;

    .#{$component}__tile {
        background-color: var(--ci-neutral100, #fff);
        border: solid 1px var(--ci-neutral200);
        box-sizing: border-box;
        border-radius: 8px;
        color: var(--ci-neutral800, #3C3C3C);
        display: flex;
        flex-direction: column;
        font-family: "Museo Sans Rounded", sans-serif;
        font-size: f.calc-em(16);
        font-weight: 600;
        height: 100%;
        justify-content: center;
        min-width: 242px;
        outline: none;
        padding: 16px;
        text-align: center;
        text-decoration: none;

        @media only screen and (min-width: $tablet-screen) {
            border: solid 1px var(--ci-neutral200);
        }

        &:focus-visible {
            border: 2px solid var(--ci-primary600);
        }

        @media only screen and (min-width: $tablet-screen) {
            &:hover,
            &:focus-visible {
                box-shadow: 0 5px 15px var(--ci-neutral400);
                color: var(--ci-primary400, #00869d);
                z-index: 1;
            }
        }
    }
}
